export default __webpack_public_path__ + "static/kh-79cc9a8ac5fa906012456816ca9d6229.svg";